import { defineComponent as _defineComponent } from 'vue'
import { useForm } from '@/util/useForm';
import { computed, onActivated, onMounted, ref, watch } from 'vue';
import NModel from '@/component/NModel/NModel.vue';
import moment from 'moment';
import { message } from 'ant-design-vue';
import { getProductList } from '@/api/marketing/discount';
import { getSimpleCategory } from '@/api/ware/category';

export default /*#__PURE__*/_defineComponent({
  __name: 'GoodsTable',
  props: {
    visible: { type: Boolean },
    disableKeys: null
  },
  emits: ['getSelectIds', 'ok', 'cancel'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean;
  disableKeys: any[];
};


watch(
  () => props.visible,
  () => {
    if (props.visible) {
      query();
      selectedRowKeys.value = [];
      let length = cacheSelectRowData.length;
      while (length) {
        cacheSelectRowData.pop();
        length--;
      }
    }
  },
  { immediate: true }
);
const getCheckboxProps = record => {
  if (props.disableKeys.includes(record.id)) {
    return {
      props: {
        disabled: true,
        name: record.name,
      },
    };
  }
  return {
    props: {
      disabled: false,
      name: record.name,
    },
  };
};
const form = useForm(); // 表单
const queryParams = ref<any>({}); // 搜索条件
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 20,
});

const loading = ref<boolean>(false); // 表格加载
const isShowDelete = ref<boolean>(false); // 删除确认框
const selectedRowKeys = ref<any[]>([]); // 选中id
const cacheSelectRowData = [] as any[][];
const dataSource = ref<any>([]);
const stock_sort = ref<string | undefined>(); // 排序
const nowPage = computed(() => pagination.value.current - 1 || 0);
const ware_category_list = ref<any[]>([]);
const ware_category_id = ref<any[]>([]);
function onAddGoods() {
  emit('ok', cacheSelectRowData.flat());
}
// 查询
async function onQueryGoods() {
  const { goods_id, goods_name, goods_type, goods_state } = form.value.getFormValue();
  queryParams.value = {
    product_id: goods_id,
    product_name: goods_name,
    goods_type,
    is_show: goods_state,
    // create_time: moment(create_time).format('X'),
    category_id: ware_category_id.value[1],
    stock_sort,
  };
  query({
    current: pagination.value.current,
    ...queryParams.value,
  });
}
async function query(params = queryParams.value) {
  const formatParams = {
    current: 1,
    limit: 10,
    ...params,
  };
  loading.value = true;
  dataSource.value = [];
  const res: any = await getProductList(formatParams);

  if (!cacheSelectRowData?.[res?.data.current - 1 || 0]) {
    cacheSelectRowData.push(new Array(0));
  }
  loading.value = false;
  pagination.value = {
    current: res?.data?.current,
    total: res?.data?.total,
    pageSize: res?.data?.limit,
  };
  dataSource.value = res?.data.detail;
}
// 清除搜索条件
function clear() {
  form.value.resetFields();
  queryParams.value = {};
  ware_category_id.value = [];
  selectedRowKeys.value = [];
  pagination.value.current = 1;
  onQueryGoods();
}
function onTableChange({ current }, filters, sorter) {
  const sort: any = sorter.order; // 排序类型，正序/倒序/不排序
  if (sort == 'ascend') {
    stock_sort.value = 'stock_asc';
  } else if (sort == 'descend') {
    stock_sort.value = 'stock_desc';
  } else {
    stock_sort.value = undefined;
  }
  query({ stock_sort: stock_sort.value, current });
  // query({ ...queryParams.value, current });
}
function Format(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}
function onSelectChange(selectedKey, selectedRow) {
  selectedRowKeys.value = selectedKey;
  if (cacheSelectRowData?.[nowPage.value]) {
    cacheSelectRowData[nowPage.value] = selectedRow;
  } else {
    cacheSelectRowData.push(selectedRow);
  }
  emit('getSelectIds', selectedRowKeys.value);
}

function onWareCategoryChange(value: any) {
  ware_category_id.value = value;
}
// 获取商品分类列表
async function fetchWareCategoryList() {
  const res = await getSimpleCategory();
  ware_category_list.value = res;
}
onMounted(() => {
  query();
  fetchWareCategoryList();
});

return { __sfc: true,props, getCheckboxProps, form, queryParams, pagination, emit, loading, isShowDelete, selectedRowKeys, cacheSelectRowData, dataSource, stock_sort, nowPage, ware_category_list, ware_category_id, onAddGoods, onQueryGoods, query, clear, onTableChange, Format, onSelectChange, onWareCategoryChange, fetchWareCategoryList, NModel }
}

})